export const FUNDRAISER = 'FUNDRAISER';
export const FUNDRAISER_ALL_ACTION = `${FUNDRAISER}/ALL`;
export const FUNDRAISER_CREATE_ACTION = `${FUNDRAISER}/CREATE`;
export const FUNDRAISER_UPDATE_ACTION = `${FUNDRAISER}/UPDATE`;
export const FUNDRAISER_LIVE_ACTION = `${FUNDRAISER}/LIVE`;
export const FUNDRAISER_BY_ID = `${FUNDRAISER}/BY_ID`;
export const FUNDRAISER_TXTPAY_ACTION = `${FUNDRAISER}/TXTPAY`;
